import React from 'react'
import './index.sass'

const MarketsTableTabs = ({ tabs, activeTab, onSelect }) => (
  <div className="markets-table-tabs">
    {tabs.map(({ id, label }) => (
      <button
        key={id}
        type="button"
        className={`markets-table-tabs__button ${activeTab === id ? 'markets-table-tabs__button--active' : ''}`}
        onClick={() => onSelect(id)}
      >
        {label}
      </button>
    ))}
  </div>
)

export default MarketsTableTabs

